export default {
    data: () => ({
        translations: {
            title: {
                el: "Ενημέρωση καμπάνιας Emails (εσωτερικό)",
                en: "Campaign Notification Emails (internal)",
                it: "Aggiornamento campagna interna (e-mail)"
            },
            notifications: {
                el: "",
                en: "Notifications",
                it: ""
            },
            notificationsInfo: {
                el: "Συμπληρώστε ένα επιπλέον email επικοινωνίας για να λαμβάνετε ειδοποιήσεις κατά τη δημιουργία και την εκτέλεση κάθε καμπάνιας.",
                en: `
                    Fill out an extra contact email to receive notifications when creating
                    and running any campaign.
                `,
                it: "Compila un'email di contatto aggiuntiva per ricevere le notifiche durante la creazione e l'esecuzione di ogni campagna"
            },
            smsEmail: {
                el: "SMS + Εmail",
                en: "SMS + Εmail",
                it: "SMS + Εmail"
            },
            smsEmailInfo: {
                el: "Συμπληρώστε το όνομα που θέλετε να εμφανίζεται κατά την αποστολή μηνυμάτων. Το όνομα πρέπει να είναι με λατινικούς χαρακτήρες και χωρίς κενά.",
                en: `
                    Fill in the name you want to show when sending messages or Email with
                    the first method. The name must be in Latin characters and without
                    spaces.
                `,
                it: "Inserisci il nome che vuoi far apparire quando invii i messaggi. Il nome deve essere in caratteri romani e senza spazi."
            },
            messageSenderName: {
                el: "Εμφανιζόμενο όνομα αποστολέα",
                en: "Message Sender Name",
                it: "Visualizzazione del nome del mittente"
            },
            messageSenderEmail: {
                el: "",
                en: "Message Sender Email",
                it: ""
            },
            emailFirstMethod: {
                el: "",
                en: "Email (First method)",
                it: ""
            },
            verifyEmail: {
                el: "",
                en: "Verify Email",
                it: ""
            },
            emailFirstMethodInfo: {
                el: "",
                en:
                    "Add the email you want to see as the sender of the campaign",
                it: ""
            },
            emailSecondMethod: {
                el: "",
                en: "Email (Second method)",
                it: ""
            },
            emailSecondMethodInfo: {
                el: "",
                en: `
                    Enter your email credentials in the table below to send email campaigns
                    through your email provider. Leave this blank and RoadCube's email
                    provider will be used.
                `,
                it: ""
            },
            host: {
                el: "",
                en: "Host",
                it: ""
            },
            name: {
                el: "Όνομα",
                en: "Name",
                it: "Nome"
            },
            email: {
                el: "Email",
                en: "Email",
                it: "Email"
            },
            password: {
                el: "Κωδικός",
                en: "Password",
                it: "Codice"
            },
            info: {
                el: "",
                en: `
                    * Sending email by priority. If the first method doesnt exists then
                    the second method will be used. If the second method doesnt exists
                    as well then RoadCube's email provider will be used.
                `,
                it: ""
            }
        }
    })
};
